import * as amplitude from './amplitude'
import {
  AnalyticsEventDomainEnum,
  AnalyticsEventEntity,
  AnalyticsEventStateEnum,
  IEventGroupData,
} from './types'
import { UserInfo } from './types'
import * as userguiding from './userguiding'

export { initAnalytics } from './init'

export const setUserInfo = (info: UserInfo) => {
  amplitude.setUserInfo(info)
  userguiding.setUserInfo(info)
}

export const sendEvent = (
  event: string,
  data: object,
  metadata: { groups: IEventGroupData } = { groups: {} },
) => {
  amplitude.sendEvent(event, data, metadata)
}

export const sendTypedEvent = (
  event: `${AnalyticsEventDomainEnum}.${Lowercase<AnalyticsEventEntity>}.${AnalyticsEventStateEnum}`,
  data: { [key: string]: string | boolean | number } = {},
  metadata: { groups: IEventGroupData } = { groups: {} },
) => {
  sendEvent(event, data, metadata)
}
